import { Component, OnInit, ViewEncapsulation, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { AllCommunityModules } from '@ag-grid-community/all-modules';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl } from '@angular/forms';
import { Location } from '@angular/common';
import { MatDialogRef, MatDialog} from '@angular/material/dialog';
import {  MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import {  MatChipInputEvent } from '@angular/material/chips';
import * as XLSX from 'xlsx';
import { ConfigurationService } from 'src/services/configuration.service';
import { LocalstorageService } from 'src/services/localstorage.service';
import { NgxToasterService } from 'src/services/ngx-toaster.service';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DropdownRendererComponent } from 'src/common/dropdown-renderer';
@Component({
  selector: 'app-version-forecast',
  templateUrl: './version-forecast.component.html',
  styleUrls: ['./version-forecast.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class VersionForecastComponent implements OnInit {
  width = '100%';
  height = '500';
  type = "msline";
  dataFormat = "json";
  dataSource;
  public submitted = false;
  public isEdit = false;
  public columnDefs = [];
  private gridApi: any;
  dropdownSettings = {};
  dropdownSettingsSingle = {};
  public tenureTypeList = [];
  public tenureTypeListTemp = [];
  public rowList = [];
  public goalTypeList = [];
  public gridOptions: any;
  public getRowHeight;
  public getRowStyle;
  public headerHeight;
  public modules = AllCommunityModules;
  public clientId = 1;
  public channelList = [{ channelId: 1, channelName: 'Retail' }];
  public channel = null;
  public csvRecords: any;
  public customerSelectedList = [];
  public selectedItemIds = [];
  public itemIdList = ['FB000038',
    'FB000084',
    'FB000063'];
  public customerList = [
    'Amazon AU',
    'Amazon CA',
    'Amazon JPN',
    'Amazon US',
    'Best Buy CA',
    'Best Buy US',
    'Synnex CA',
    'Synnex US',
    'WMT'

  ];
  public timeframeSelectedList = [];
  public itemSeletedList = [];
  public timeframeList = [];
  public versionList = [];
  public monthList = [];
  public itemList = [
    'Quest 64GB - US/CA/JP/TW',
    'Quest 128GB - US/CA/JP/TW',
    'Portal+ Black',
    'Oculus Go Relaxed Facial Interface',
    'Oculus Go Charging Cable',
    'Oculus Rift S Headband',
    'Oculus Rift Headset (only)',
    'Oculus Rift S',
    'Audio Arms',
    'Oculus Touch - Left Controller',
    'Oculus Quest UK/IE/HK/SG 64GB',
    'Rock Band VR connector',
    'Earphones',
    'Quest 64GB - EU',
    'Portal Black',
    'Quest 64GB - UK/IE/HK/SG',
    'Oculus Go Controller (Grade B)',
    'Portal Black (Gen 2)',
    'Touch',
    'Portal TV (Catalina)',
    'Oculus Rift S Standard Facial Interface',
    'Portal Mini - Dark (CA)',
    'Portal Dark - (CA)',
    'Oculus Go Carry Case',
    'Portal TV (UK/IE)',
    'Oculus Go Standalone VR 32 GB',
    'Portal+ White',
    'Rift - Marvel Bundle',
    'Unknown Oculus Product',
    'Portal Mini - White',
    'Portal Light - (CA)',
    'Oculus Go - 64GB',
    'Quest 64GB - AU/NZ',
    'Oculus Quest 128GB',
    'Sensor',
    'Quest 128GB and Case Bundle (S10252627@AMA+S10260629)',
    'Portal + White - CA',
    'Quest 128GB - AU/NZ',
    'Portal White - CA',
    'Oculus Go Controller',
    'Portal Mini (Omni)',
    'Portal White',
    'Portal White (Gen 2)',
    'Portal Mini - Black',
    'Oculus Quest IEM',
    'Portal Mini - Dark (EU)',
    'Oculus Quest Travel case',
    'Portal (Atlas)',
    'Oculus Quest UK/IE/HK/SG 128GB',
    'Portal+ Dark - (EU)',
    'Portal Mini - White (CA)',
    'Quest 64GB and Case Bundle (S10252626@AMA+S10260629)',
    'Portal TV (CA)',
    'Oculus Go - 32GB',
    'Oculus Go 64GB Headset (Grade B)',
    'Rift S',
    'Rift S Device',
    'Oculus Rift',
    '15W USB-C Power Adapter for the United Kingdom, Ireland, Hong Kong and Singapore',
    'SID (Simple Input Device)',
    '15W USB-C Power Adapter for EU',
    'Quest 128GB -EU',
    'HMD cable',
    'Oculus Go - 32GB ROW',
    'Online Game Code',
    'Oculus Touch - Right Controller',
    'Hardbundle',
    'Oculus Go Facial Interface Eye Rings',
    'Portal Mini - White (EU)',
    'Portal+ Light - (EU)',
    'Oculus Quest 64GB',
    'Oculus Go - 64GB ROW',
    'Oculus Touch Right Hand Controller',
    '15W USB-C Power Adapter for USA, Canada, Japan and Taiwan',
    'Portal TV (EU)',
    'Portal TV',
    'Portal Dark - (UK/IE)',
    'Portal + Black - CA',
    'Quest 128GB - UK/IE/HK/SG',
    'Oculus Go - Carrying Case',
    'Oculus Go Fitted Facial Interface',
    'Portal+ Light - (UK/IE)',
    'Oculus Sensor',
    'Oculus Go Controller Lanyard',
    'Portal+ Dark - (UK/IE)"',
    'Quest In-ear Headphones',
    'Portal Dark - (EU)',
    '15W USB-C Power Adapter for Australia and New Zealand',
    'Oculus Go Glasses Spacer',
    'Oculus Go Power Adapter',
    'Portal Light - (UK/IE)',
    'Oculus Go 32GB Headset (Grade B)',
    'Quest Travel Case',
    'Oculus Quest Standard Facial Interface',
    'Portal Light - (EU)',
    'Rift',
    'Portal Black - CA',
    'Portal Mini - White (UK/IE)',
    'Oculus Go Standalone VR 64 GB',
    'Portal Mini - Dark (UK/IE)',
    'Oculus Touch Left Hand Controller'
  ];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredCustomers: Observable<any[]>;
  filteredItems: Observable<any[]>;
  filteredTimeframe: Observable<any[]>;
  public seletedYear = null;
  public seletedVersion = null;
  public selectedMonth = null;
  public defaultRow = {};
  public selectAll = true;
  searchCustomer = new FormControl();
  searchItem = new FormControl();
  searchTimeframe = new FormControl();
  files: File[] = [];
  @ViewChild('ExcelImport') excelImport: TemplateRef<any>;
  @ViewChild('dialog') dialogTemplate: TemplateRef<any>;
  @ViewChild('searchItemInput', { static: true }) searchItemInput: ElementRef;
  @ViewChild('searchCustomerInput', { static: true }) searchCustomerInput: ElementRef;
  tempList = [];
  totalCalculatedList = [];
  chartDatasets = [];
  simulatedChartDatasets = [];
  barChartDatasets = [];
  simulatedBarChartDatasets = [];
  xAxis = [];
  yAxis = [];
  xAxisSimulated = [];
  view = [700, 700];
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = false;
  legendTitle = 'Legend';
  legendPosition = 'right';
  showXAxisLabel = true;
  xAxisLabel = 'Sales QTY';
  showYAxisLabel = true;
  yAxisLabel = 'Time Period';
  showGridLines = true;
  innerPadding = '10%';
  animations: boolean = true;
  lineChartScheme = {
    name: 'coolthree',
    selectable: true,
    group: 'Ordinal',
    domain: ['#01579b', '#7aa3e5', '#a8385d', '#00bfa5']
  };

  comboBarScheme = {
    name: 'singleLightBlue',
    selectable: true,
    group: 'Ordinal',
    domain: ['#7aa3e5']
  };

  showRightYAxisLabel: boolean = true;
  yAxisLabelRight: string = '';
  tempColDefs = [];
  chooserList = [
    { name: 'Expotential Smoothing', checked: true },
    { name: 'Linear Regression', checked: true },
    { name: `Holt's Double Expotenial Smoothing`, checked: true },
    { name: 'Seasonality', checked: true },
    { name: 'Final Expotential Smoothing', checked: true },
    { name: 'Final Linear Regression', checked: true },
    { name: `Final Holt's Double Expotenial Smoothing`, checked: true },
    { name: 'Final Total Forecast', checked: true },
    { name: 'Customer Forecast', checked: true },
    { name: 'Monthly Budget', checked: true },
    { name: 'Yearly Budget', checked: true },
    { name: 'Marketing Spend', checked: true },
    { name: 'LY Actuals', checked: true },
    { name: 'Like Item LY', checked: true },
    { name: 'Notes', checked: true }
  ]
  // public  date = { begin: new Date(2018, 7, 5), end: new Date(2018, 7, 25) };
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public location: Location,
    public spinner: NgxSpinnerService,
    public toastr: NgxToasterService,
    public storage: LocalstorageService,
    public dialogRef: MatDialogRef<any>,
    public configurationService: ConfigurationService,
    public dialog: MatDialog) {
    this.gridOptions = {
      rowClassRules: {
        // apply green to 2008
        'rag-green-outer': function (params) { return params.data.secondValue === 'Final Total Forecast'; },
        'rag-grey-outer': function (params) { return (params.data.columnValue === 'Quest 128GB') },
        // 'rag-white': function (params) { return (params.data.columnValue === 'Quest 64GB'); },
        'rag-border-outer': function (params) {
          return params.data.secondValue === 'Notes';
        },
        'rag-border-top-outer': function (params) {
          return params.data.secondValue === 'Expotential Smoothing';
        },
        // // apply amber 2004
        // 'rag-amber-outer': function(params) { return params.data.year === 2004; },

        // // apply red to 2000
        // 'rag-red-outer': function(params) { return params.data.year === 2000; }
      },
      frameworkComponents: {
        'dropdownRenderer': DropdownRendererComponent
      },
      // pagination: true,
      // paginationAutoPageSize: true,
      // suppressMenuHide: true,
    };
    this.headerHeight = 30;
    this.gridOptions.getRowHeight = function (params) {
      return 30;
    };
    this.gridOptions.getRowStyle = function (params) {
      if (params.data && params.data.apBudgetTenureName && typeof params.data.apBudgetTenureName === 'string') {
        if (params.data && params.data.apBudgetTenureName && params.data.apBudgetTenureName.endsWith('FY21')) {
          return { 'background-color': '#D6EAF8' };
        }
        if (params.data && params.data.apBudgetTenureName && params.data.apBudgetTenureName.startsWith('Q')) {
          return { 'background-color': '#3498DB' };
        }
        if (params.data && params.data.apBudgetTenureName && params.data.apBudgetTenureName.startsWith('WK')) {
          return { 'background-color': '' };
        }
      }
    };
  }
  openDialog(data, templateRef?: TemplateRef<any>): void {
    this.dialogRef = this.dialog.open(this.dialogTemplate, { width: '500px', data: data || {} });
  }
  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 0,
      allowSearchFilter: true
    };
    this.dropdownSettingsSingle = {
      singleSelection: true,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 0,
      allowSearchFilter: true
    };
    this.customerList = (this.customerList as any).map(customer => ({
      item_id: customer,
      item_text: customer
    }));
    this.itemList = (this.itemList as any).map(item => ({
      item_id: item,
      item_text: item
    }));
    this.versionList.push(
      'Commit',
      'V1',
      'V2',
      'V3'
    );
    for (let index = 0; index < 12; index++) {
      const date = new Date(2009, index, 10);  // 2009-11-10
      const month = date.toLocaleString('default', { month: 'long' });
      const shortMonth = date.toLocaleString('default', { month: 'short' });
      this.monthList.push(
        {
          item_id: `${shortMonth}`, item_text: `${month} FY20`
        });
    }
    this.customerList = (this.customerList as any).sort((a, b) => a.item_id < b.item_id ? -1 : 1)
    this.itemList = (this.itemList as any).sort((a, b) => a.item_id < b.item_id ? -1 : 1)
    this.searchCustomer.setValue('');
    this.searchItem.setValue('');
    this.columnDefs = [
      {
        headerName: '',
        width: 150,
        field: 'firstValue',
        pinned: 'abcd',
        cellRenderer: params => `<b>${params.value ? params.value : ''}</b>`,
        cellStyle: { 'background-color': 'white' }
      },
      {
        headerName: '',
        width: 300,
        pinned: 'abcd',
        field: 'secondValue',
        cellRenderer: '',
        cellRendererParams: (params) => {
          const items = ['Primary Method Base', 'Expotential Smoothing', 'Linear Regression', `Holt's Double Expotential Smoothing`];
          const obj = {
            isDropDown: items.includes(params.data.secondValue) ? true : false, // pass the field value here
            onChange: this.filterData.bind(this),
          }
          return obj;

        },
        // cellStyle: params => params.rowData && params.rowData.rowIndex % 2 === 0 ? { 'background-color': 'white' } : { 'background-color': 'lightgray' }
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '01/05/2020',
            width: 120,
            field: 'janw1',
            suppressSizeToFit: true,
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          }
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '01/12/2020',
            width: 120,
            field: 'janw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '01/19/2020',
            width: 120,
            field: 'janw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '01/26/2020',
            width: 120,
            field: 'janw4',
            pivotIndex: 0,
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },

        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: 'Ttl January',
            width: 150,
            field: 'ttlJanuary',
            valueGetter: (params) => {
              if (params.data.ttlJanuary) {
                return params.data.ttlJanuary;
              } else {
                return '';
              }
            },
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },

        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '02/02/2020',
            width: 120,
            field: 'febw1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '02/09/2020',
            width: 120,
            field: 'febw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '02/16/2020',
            width: 120,
            field: 'febw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '02/23/2020',
            width: 120,
            field: 'febw4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: 'Ttl February',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlFebruary) {
                return params.data.ttlFebruary;
              } else {
                return '';
              }
            },
            field: 'ttlFebruary',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '03/01/2020',
            width: 120,
            field: 'marchw1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '03/08/2020',
            width: 120,
            field: 'marchw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '03/15/2020',
            width: 120,
            field: 'marchw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '03/22/2020',
            width: 120,
            field: 'marchw4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '03/29/2020',
            width: 120,
            field: 'marchw5',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: 'Ttl March',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlMarch) {
                return params.data.ttlMarch;
              } else {
                return '';
              }
            },
            field: 'ttlMarch',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: 'Q1',
            width: 120,
            field: 'q1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            valueGetter: (params) => {
              if (params.data.q1) {
                return params.data.q1;
              } else {
                return '';
              }
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '04/05/2020',
            width: 120,
            field: 'aprilw1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '04/12/2020',
            width: 120,
            field: 'aprilw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '04/19/2020',
            width: 120,
            field: 'aprilw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '04/26/2020',
            width: 120,
            field: 'aprilw4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: 'Ttl April',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlApril) {
                return params.data.ttlApril;
              } else {
                return '';
              }
            },
            field: 'ttlApril',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '05/03/2020',
            width: 120,
            field: 'mayw1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '05/10/2020',
            width: 120,
            field: 'mayw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '05/17/2020',
            width: 120,
            field: 'mayw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '05/24/2020',
            width: 120,
            field: 'mayw4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: 'Ttl May',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlMay) {
                return params.data.ttlMay;
              } else {
                return '';
              }
            },
            field: 'ttlMay',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '05/31/2020',
            width: 120,
            field: 'junew1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '06/07/2020',
            width: 120,
            field: 'junew2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '06/14/2020',
            width: 120,
            field: 'junew3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '06/21/2020',
            width: 120,
            field: 'junew4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '06/28/2020',
            width: 120,
            field: 'junew5',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: 'Ttl June',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlJune) {
                return params.data.ttlJune;
              } else {
                return '';
              }
            },
            field: 'ttlJune',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: 'Q2',
            width: 120,
            field: 'q2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            valueGetter: (params) => {
              if (params.data.q2) {
                return params.data.q2;
              } else {
                return '';
              }
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '07/05/2020',
            width: 120,
            field: 'julyw1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '07/12/2020',
            width: 120,
            field: 'julyw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '07/19/2020',
            width: 120,
            field: 'julyw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '07/26/2020',
            width: 120,
            field: 'julyw4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: 'Ttl July',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlJuly) {
                return params.data.ttlJuly;
              } else {
                return '';
              }
            },
            field: 'ttlJuly',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '08/02/2020',
            width: 120,
            field: 'augw1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '08/09/2020',
            width: 120,
            field: 'augw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '08/16/2020',
            width: 120,
            field: 'augw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '08/23/2020',
            width: 120,
            field: 'augw4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: 'Ttl August',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlAugust) {
                return params.data.ttlAugust;
              } else {
                return '';
              }
            },
            field: 'ttlAugust',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '08/30/2020',
            width: 120,
            field: 'sepw1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '09/13/2020',
            width: 120,
            field: 'sepw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '09/20/2020',
            width: 120,
            field: 'sepw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '09/27/2020',
            width: 120,
            field: 'sepw4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: 'Ttl September',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlSeptember) {
                return params.data.ttlSeptember;
              } else {
                return '';
              }
            },
            field: 'ttlSeptember',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: 'Q3',
            width: 120,
            field: 'q3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            valueGetter: (params) => {
              if (params.data.q3) {
                return params.data.q3;
              } else {
                return '';
              }
            },
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [

          {
            headerName: '10/04/2020',
            width: 120,
            field: 'octw1',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '10/11/2020',
            width: 120,
            field: 'octw2',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ]
      },
      {
        headerName: 'Actual',
        field: '',
        children: [
          {
            headerName: '10/18/2020',
            width: 120,
            field: 'octw3',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' }
          },
        ],
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '10/25/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' },
            width: 120,
            field: 'octw4',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: 'Ttl October',
            width: 150,
            valueGetter: (params) => {
              if (params.data.ttlOctober) {
                return params.data.ttlOctober;
              } else {
                return '';
              }
            },
            field: 'ttlOctober',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '11/01/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' },
            width: 120,
            field: 'novw1',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '11/08/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' },
            width: 120,
            field: 'novw2',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '11/15/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' },
            width: 120,
            field: 'novw3',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '11/22/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' },
            width: 120,
            field: 'novw4',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: 'Ttl November',
            width: 150,
            field: 'ttlNovember',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            valueGetter: (params) => {
              if (params.data.ttlNovember) {
                return params.data.ttlNovember;
              } else {
                return '';
              }
            }
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '11/29/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' },
            width: 120,
            field: 'novw5',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '12/06/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' },
            width: 120,
            field: 'decw1',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '12/13/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' },
            width: 120,
            field: 'decw2',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '12/20/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' },
            width: 120,
            field: 'decw3',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: '12/27/2020',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' },
            width: 120,
            field: 'decw4',
          },
        ]
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: 'Ttl December',
            width: 150,
            field: 'ttlDecember',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            valueGetter: (params) => {
              if (params.data.ttlDecember) {
                return params.data.ttlDecember;
              } else {
                return '';
              }
            }
          },
        ],
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: 'Q4',
            width: 120,
            field: 'q4',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            valueGetter: (params) => {
              if (params.data.q4 && params.data.secondValue === 'Seasonality') {
                return Number(params.data.q4).toFixed(2);
              } else {
                if (params.data.q4) {
                  return Number(params.data.q4);
                } else {
                  return '';
                }
              }
            }
          }
        ],
      },
      {
        headerName: 'Forecast',
        field: '',
        children: [
          {
            headerName: 'Total Year',
            width: 120,
            field: 'totalYear',
            valueSetter: function (params) {
              params.data[params.colDef.field] = Number(params.newValue);
              return true
            },
            valueGetter: (params) => {
              if (params.data.totalYear) {
                return params.data.totalYear;
              } else {
                return '';
              }
            }
          }
        ]
      },

    ];
    this.tempColDefs = JSON.parse(JSON.stringify(this.columnDefs));
    const defaultObject = {
      firstValue: 'Quest 128GB',
      secondValue: 'Final Base',
      janw1: 957,
      janw2: 974,
      janw3: 832,
      janw4: 969,
      janw5: 969,
      ttlJanuary: 3731,
      febw1: 957,
      febw2: 974,
      febw3: 832,
      febw4: 969,
      febw5: 969,
      ttlFebruary: 3731,
      marchw1: 957,
      marchw2: 974,
      marchw3: 832,
      marchw4: 969,
      marchw5: 969,
      ttlMarch: 3731,
      q1: 1000,
      aprilw1: 957,
      aprilw2: 974,
      aprilw3: 832,
      aprilw4: 969,
      aprilw5: 969,
      ttlApril: 3731,
      mayw1: 957,
      mayw2: 974,
      mayw3: 832,
      mayw4: 969,
      mayw5: 969,
      ttlMay: 3731,
      junew1: 957,
      junew2: 974,
      junew3: 832,
      junew4: 969,
      junew5: 969,
      ttlJune: 3731,
      q2: 1000,
      julyw1: 957,
      julyw2: 974,
      julyw3: 832,
      julyw4: 969,
      julyw5: 969,
      ttlJuly: 3731,
      augw1: 957,
      augw2: 974,
      augw3: 832,
      augw4: 969,
      augw5: 969,
      ttlAugust: 3731,
      sepw1: 957,
      sepw2: 974,
      sepw3: 832,
      sepw4: 969,
      sepw5: 969,
      ttlSepetember: 3731,
      q3: 1000,
      octw1: 957,
      octw2: 974,
      octw3: 832,
      octw4: 969,
      octw5: 969,
      ttlOctober: 3731,
      novw1: 957,
      novw2: 974,
      novw3: 832,
      novw4: 969,
      novw5: 969,
      ttlNovemebr: 3731,
      decw1: 957,
      decw2: 974,
      decw3: 832,
      decw4: 969,
      decw5: 969,
      ttlDecember: 3731,
      q4: 1000,
      totalYear: 5000
    }
    // this.columnDefs.forEach((column) => this.defaultRow[column.field] = Math.random());
    const manupulatedList = [];
    const obj = JSON.parse(JSON.stringify(this.defaultRow));
    for (let index = 1; index <= 48; index++) {
      this.rowList.push(defaultObject);
    }
    // this.configurationService.importExcel('version-forecast').subscribe(res => {
    //   this.loadFile(res);
    // });
    this.rowList = [{"columnValue":"Quest 128GB","secondValue":"Expotential Smoothing","janw1":909.055,"janw2":925.0149999999999,"janw3":790.0199999999999,"janw4":920.3599999999999,"ttlJanuary":550,"febw1":600,"febw2":3000,"febw3":2200,"febw4":1044.05,"ttlFebruary":2414.615,"marchw1":2517.6899999999996,"marchw2":2630.075,"marchw3":1616.6149999999998,"marchw4":1557.4299999999998,"marchw5":1677.7949999999998,"ttlMarch":760.7599999999999,"q1":996.8349999999999,"aprilw1":936.9849999999999,"aprilw2":1047.375,"aprilw3":678.3,"aprilw4":1068.6549999999997,"ttlApril":526.68,"mayw1":658.35,"mayw2":799.9949999999999,"mayw3":985.5299999999999,"mayw4":986.1949999999998,"ttlMay":744.1349999999999,"junew1":924.3499999999998,"junew2":958.2649999999999,"junew3":708.8899999999999,"junew4":516.7049999999999,"junew5":963.5849999999999,"ttlJune":1622.6,"q2":3845.0299999999993,"julyw1":781.375,"julyw2":807.9749999999999,"julyw3":783.3699999999999,"julyw4":753.4449999999998,"ttlJuly":886.4449999999998,"augw1":709.555,"augw2":665,"augw3":665,"augw4":620.4449999999999,"ttlAugust":620.4449999999999,"sepw1":532,"sepw2":487.445,"sepw3":487.445,"sepw4":487.445,"sepw5":487.445,"ttlSeptember":443.55499999999995,"q3":532,"octw1":487.445,"octw2":1821.2355,"octw3":1817.046,"octw4":1697.3459999999998,"ttlOctober":7279.5555,"novw1":1697.3459999999998,"novw2":1451.961,"novw3":1332.2609999999997,"novw4":1332.2609999999997,"ttlNovember":5813.829,"novw5":1332.2609999999997,"decw1":1329.867,"decw2":1210.7655,"decw3":1451.961,"decw4":1329.867,"ttlDecember":0,"q4":0,"totalYear":0},{"columnValue":"Quest 128GB","secondValue":"Linear Regression","janw1":727.244,"janw2":740.012,"janw3":632.016,"janw4":736.288,"ttlJanuary":440,"febw1":480,"febw2":2400,"febw3":1760,"febw4":835.24,"ttlFebruary":1931.692,"marchw1":2014.1519999999998,"marchw2":2104.06,"marchw3":1293.292,"marchw4":1245.944,"marchw5":1342.2359999999999,"ttlMarch":608.608,"q1":797.468,"aprilw1":749.588,"aprilw2":837.9000000000001,"aprilw3":542.64,"aprilw4":854.9239999999999,"ttlApril":421.344,"mayw1":526.6800000000001,"mayw2":639.996,"mayw3":788.424,"mayw4":788.9559999999999,"ttlMay":595.3079999999999,"junew1":739.4799999999999,"junew2":766.612,"junew3":567.112,"junew4":413.364,"junew5":770.8679999999999,"ttlJune":1298.08,"q2":3076.0239999999994,"julyw1":625.1,"julyw2":646.38,"julyw3":626.6959999999999,"julyw4":602.7559999999999,"ttlJuly":709.156,"augw1":567.644,"augw2":532,"augw3":532,"augw4":496.356,"ttlAugust":496.356,"sepw1":425.6,"sepw2":389.956,"sepw3":389.956,"sepw4":389.956,"sepw5":389.956,"ttlSeptember":354.844,"q3":425.6,"octw1":389.956,"octw2":1416.5165,"octw3":1413.258,"octw4":1320.158,"ttlOctober":5661.8765,"novw1":1320.158,"novw2":1129.3029999999999,"novw3":1036.2029999999997,"novw4":1036.2029999999997,"ttlNovember":4521.866999999999,"novw5":1036.2029999999997,"decw1":1034.341,"decw2":941.7064999999998,"decw3":1129.3029999999999,"decw4":1034.341,"ttlDecember":0},{"columnValue":"Quest 128GB","secondValue":"Holt's Double Expotenial Smoothing","janw1":1090.866,"janw2":1110.0179999999998,"janw3":948.0239999999998,"janw4":1104.4319999999998,"ttlJanuary":660,"febw1":720,"febw2":3600,"febw3":2640,"febw4":1252.86,"ttlFebruary":2897.5379999999996,"marchw1":3021.2279999999996,"marchw2":3156.0899999999997,"marchw3":1939.9379999999996,"marchw4":1868.9159999999997,"marchw5":2013.3539999999998,"ttlMarch":912.9119999999998,"q1":1196.2019999999998,"aprilw1":1124.3819999999998,"aprilw2":1256.85,"aprilw3":813.9599999999999,"aprilw4":1282.3859999999997,"ttlApril":632.016,"mayw1":790.02,"mayw2":959.9939999999998,"mayw3":1182.6359999999997,"mayw4":1183.4339999999997,"ttlMay":892.9619999999999,"junew1":1109.2199999999998,"junew2":1149.918,"junew3":850.6679999999998,"junew4":620.0459999999999,"junew5":1156.302,"ttlJune":1947.12,"q2":4614.035999999999,"julyw1":937.65,"julyw2":969.5699999999998,"julyw3":940.0439999999999,"julyw4":904.1339999999998,"ttlJuly":1063.7339999999997,"augw1":851.4659999999999,"augw2":798,"augw3":798,"augw4":744.5339999999999,"ttlAugust":744.5339999999999,"sepw1":638.4,"sepw2":584.934,"sepw3":584.934,"sepw4":584.934,"sepw5":584.934,"ttlSeptember":532.266,"q3":638.4,"octw1":584.934,"octw2":0,"octw3":0,"octw4":0,"ttlOctober":0,"novw1":0,"novw2":0,"novw3":0,"novw4":0,"ttlNovember":0,"novw5":0,"decw1":0,"decw2":0,"decw3":0,"decw4":0,"ttlDecember":0,"q4":0,"totalYear":0},{"columnValue":"Quest 128GB","secondValue":"Event Lift","janw1":410.09999999999997,"janw2":417.3,"janw3":356.4,"janw4":415.2,"ttlJanuary":500,"febw1":405.59999999999997,"febw2":332.7,"febw3":565.8,"febw4":471,"ttlFebruary":1089.3,"marchw1":1135.8,"marchw2":1186.5,"marchw3":729.3,"marchw4":702.6,"marchw5":756.9,"ttlMarch":343.2,"q1":449.7,"aprilw1":422.7,"aprilw2":472.5,"aprilw3":306,"aprilw4":482.09999999999997,"ttlApril":237.6,"mayw1":297,"mayw2":360.9,"mayw3":444.59999999999997,"mayw4":444.9,"ttlMay":335.7,"junew1":417,"junew2":432.3,"junew3":319.8,"junew4":233.1,"junew5":434.7,"ttlJune":732,"q2":1734.6,"julyw1":352.5,"julyw2":364.5,"julyw3":353.4,"julyw4":339.9,"ttlJuly":399.9,"augw1":320.09999999999997,"augw2":300,"augw3":300,"augw4":279.9,"ttlAugust":279.9,"sepw1":240,"sepw2":219.9,"sepw3":219.9,"sepw4":219.9,"sepw5":219.9,"ttlSeptember":200.1,"q3":240,"octw1":219.9,"octw2":665,"octw3":665,"octw4":620.4449999999999,"ttlOctober":2170.345,"novw1":620.4449999999999,"novw2":532,"novw3":487.445,"novw4":487.445,"ttlNovember":2127.335,"novw5":487.445,"decw1":487.445,"decw2":443.55499999999995,"decw3":532,"decw4":487.445,"ttlDecember":4245.228,"q4":12311.8848,"totalYear":22959.410399999997},{"columnValue":"Quest 128GB","secondValue":"Seasonality","janw1":1.2,"janw2":1.2,"janw3":1.2,"janw4":1.2,"ttlJanuary":1.2,"febw1":1.2,"febw2":1.2,"febw3":1.2,"febw4":1.2,"ttlFebruary":1.2,"marchw1":1.2,"marchw2":1.2,"marchw3":1.2,"marchw4":1.2,"marchw5":1.2,"ttlMarch":1.2,"q1":1.2,"aprilw1":1.2,"aprilw2":1.2,"aprilw3":1.2,"aprilw4":1.2,"ttlApril":1.2,"mayw1":1.2,"mayw2":1.2,"mayw3":1.2,"mayw4":1.2,"ttlMay":1.2,"junew1":1.2,"junew2":1.2,"junew3":1.2,"junew4":1.2,"junew5":1.2,"ttlJune":1.2,"q2":1.2,"julyw1":1.2,"julyw2":1.2,"julyw3":1.2,"julyw4":1.2,"ttlJuly":1.2,"augw1":1.2,"augw2":1.2,"augw3":1.2,"augw4":1.2,"ttlAugust":1.2,"sepw1":1.2,"sepw2":1.2,"sepw3":1.2,"sepw4":1.2,"sepw5":1.2,"ttlSeptember":1.2,"q3":1.2,"octw1":1.2,"octw2":300,"octw3":300,"octw4":279.9,"ttlOctober":881.1,"novw1":279.9,"novw2":240,"novw3":219.9,"novw4":219.9,"ttlNovember":959.6999999999999,"novw5":219.9,"decw1":219.9,"decw2":200.1,"decw3":240,"decw4":219.9,"ttlDecember":2932.8,"q4":8687.214,"totalYear":18045.012},{"columnValue":"Quest 128GB","firstValue":"Version: ","secondValue":"Final Expotential Smoothing","janw1":1582.9859999999999,"janw2":1610.7779999999998,"janw3":1375.7039999999997,"janw4":1602.6719999999998,"ttlJanuary":1260,"febw1":1206.7199999999998,"febw2":3999.24,"febw3":3318.96,"febw4":1818.06,"ttlFebruary":4204.697999999999,"marchw1":4384.187999999999,"marchw2":4579.889999999999,"marchw3":2815.098,"marchw4":2712.0359999999996,"marchw5":2921.6339999999996,"ttlMarch":1324.7519999999997,"q1":1735.8419999999999,"aprilw1":1631.6219999999998,"aprilw2":1823.85,"aprilw3":1181.1599999999999,"aprilw4":1860.9059999999995,"ttlApril":917.136,"mayw1":1146.42,"mayw2":1393.0739999999998,"mayw3":1716.1559999999997,"mayw4":1717.3139999999996,"ttlMay":1295.8019999999997,"junew1":1609.62,"junew2":1668.6779999999997,"junew3":1234.4279999999997,"junew4":899.766,"junew5":1677.9419999999998,"ttlJune":2825.52,"q2":6695.555999999999,"julyw1":1360.6499999999999,"julyw2":1406.9699999999998,"julyw3":1364.124,"julyw4":1312.0139999999997,"ttlJuly":1543.6139999999998,"augw1":1235.586,"augw2":1158,"augw3":1158,"augw4":1080.4139999999998,"ttlAugust":1080.4139999999998,"sepw1":926.4,"sepw2":848.814,"sepw3":848.814,"sepw4":848.814,"sepw5":848.814,"ttlSeptember":772.386,"q3":926.4,"octw1":848.814,"octw2":1.2,"octw3":1.2,"octw4":1.2,"ttlOctober":852.414,"novw1":1.2,"novw2":1.2,"novw3":1.2,"novw4":1.2,"ttlNovember":4.8,"novw5":1.2,"decw1":1.2,"decw2":1.2,"decw3":1.2,"decw4":1.2,"ttlDecember":0,"q4":586.4,"totalYear":7051.2},{"columnValue":"Quest 128GB","firstValue":"Commit","secondValue":"Final Linear Regression","janw1":1364.8128,"janw2":1388.7743999999998,"janw3":1186.0991999999999,"janw4":1381.7856,"ttlJanuary":1128,"febw1":1062.7199999999998,"febw2":3279.24,"febw3":2790.96,"febw4":1567.488,"ttlFebruary":3625.1904,"marchw1":3779.9423999999995,"marchw2":3948.6719999999996,"marchw3":2427.1103999999996,"marchw4":2338.2527999999998,"marchw5":2518.9631999999997,"ttlMarch":1142.1696,"q1":1496.6015999999997,"aprilw1":1406.7456,"aprilw2":1572.48,"aprilw3":1018.3679999999999,"aprilw4":1604.4288,"ttlApril":790.7327999999999,"mayw1":988.416,"mayw2":1201.0752,"mayw3":1479.6287999999997,"mayw4":1480.6271999999997,"ttlMay":1117.2095999999997,"junew1":1387.776,"junew2":1438.6944,"junew3":1064.2944,"junew4":775.7567999999999,"junew5":1446.6816,"ttlJune":2436.096,"q2":5772.748799999999,"julyw1":1173.12,"julyw2":1213.056,"julyw3":1176.1151999999997,"julyw4":1131.1871999999998,"ttlJuly":1330.8672,"augw1":1065.2928,"augw2":998.4,"augw3":998.4,"augw4":931.5071999999999,"ttlAugust":931.5071999999999,"sepw1":798.72,"sepw2":731.8272,"sepw3":731.8272,"sepw4":731.8272,"sepw5":731.8272,"ttlSeptember":665.9327999999999,"q3":798.72,"octw1":731.8272,"octw2":0,"octw3":0,"octw4":0,"ttlOctober":0,"novw1":0,"novw2":0,"novw3":0,"novw4":0,"ttlNovember":0,"novw5":0,"decw1":0,"decw2":0,"decw3":0,"decw4":0,"ttlDecember":0,"q4":0,"totalYear":0},{"columnValue":"Quest 128GB","secondValue":"Final Holt's Double Expotenial Smoothing","janw1":1801.1591999999998,"janw2":1832.7815999999996,"janw3":1565.3087999999996,"janw4":1823.5583999999997,"ttlJanuary":1392,"febw1":1350.7199999999998,"febw2":4719.24,"febw3":3846.96,"febw4":2068.6319999999996,"ttlFebruary":4784.205599999999,"marchw1":4988.433599999999,"marchw2":5211.108,"marchw3":3203.085599999999,"marchw4":3085.8191999999995,"marchw5":3324.3048,"ttlMarch":1507.3343999999997,"q1":1975.0823999999998,"aprilw1":1856.4983999999997,"aprilw2":2075.22,"aprilw3":1343.952,"aprilw4":2117.3831999999993,"ttlApril":1043.5392,"mayw1":1304.424,"mayw2":1585.0727999999997,"mayw3":1952.6831999999995,"mayw4":1954.0007999999998,"ttlMay":1474.3943999999997,"junew1":1831.4639999999997,"junew2":1898.6615999999997,"junew3":1404.5615999999998,"junew4":1023.7751999999999,"junew5":1909.2024,"ttlJune":3214.944,"q2":7618.363199999998,"julyw1":1548.18,"julyw2":1600.8839999999996,"julyw3":1552.1327999999999,"julyw4":1492.8407999999995,"ttlJuly":1756.3607999999995,"augw1":1405.8791999999996,"augw2":1317.6,"augw3":1317.6,"augw4":1229.3207999999997,"ttlAugust":1229.3207999999997,"sepw1":1054.08,"sepw2":965.8007999999999,"sepw3":965.8007999999999,"sepw4":965.8007999999999,"sepw5":965.8007999999999,"ttlSeptember":878.8392,"q3":1054.08,"octw1":965.8007999999999,"octw2":1158,"octw3":1158,"octw4":1080.4139999999998,"ttlOctober":4362.2148,"novw1":1080.4139999999998,"novw2":926.4,"novw3":848.814,"novw4":848.814,"ttlNovember":3704.4419999999996,"novw5":848.814,"decw1":848.814,"decw2":772.386,"decw3":926.4,"decw4":848.814,"ttlDecember":0,"q4":0,"totalYear":0},{"columnValue":"Quest 128GB","firstValue":"Quest 128GB","secondValue":"Final Total Forecast","janw1":1750,"janw2":1600,"janw3":1500,"janw4":1550,"ttlJanuary":1260,"febw1":1206.7199999999998,"febw2":3999.24,"febw3":3318.96,"febw4":1818.06,"ttlFebruary":4204.697999999999,"marchw1":4384.187999999999,"marchw2":4579.889999999999,"marchw3":2815.098,"marchw4":2712.0359999999996,"marchw5":2921.6339999999996,"ttlMarch":1324.7519999999997,"q1":1735.8419999999999,"aprilw1":1631.6219999999998,"aprilw2":1823.85,"aprilw3":1181.1599999999999,"aprilw4":1860.9059999999995,"ttlApril":917.136,"mayw1":1146.42,"mayw2":1393.0739999999998,"mayw3":1716.1559999999997,"mayw4":1717.3139999999996,"ttlMay":1295.8019999999997,"junew1":1609.62,"junew2":1668.6779999999997,"junew3":1234.4279999999997,"junew4":899.766,"junew5":1677.9419999999998,"ttlJune":2825.52,"q2":6695.555999999999,"julyw1":1360.6499999999999,"julyw2":1406.9699999999998,"julyw3":1364.124,"julyw4":1312.0139999999997,"ttlJuly":1543.6139999999998,"augw1":1235.586,"augw2":1158,"augw3":1158,"augw4":1080.4139999999998,"ttlAugust":1080.4139999999998,"sepw1":926.4,"sepw2":848.814,"sepw3":848.814,"sepw4":848.814,"sepw5":848.814,"ttlSeptember":772.386,"q3":926.4,"octw1":848.814,"octw2":800,"octw3":800,"octw4":746.4,"ttlOctober":3195.214,"novw1":746.4,"novw2":640,"novw3":586.4,"novw4":586.4,"ttlNovember":2559.2,"novw5":586.4,"decw1":586.4,"decw2":533.6,"decw3":640,"decw4":586.4,"ttlDecember":0,"q4":0,"totalYear":0},{"columnValue":"Quest 128GB","firstValue":"BBY US","secondValue":"Customer Forecast","janw1":1093.6000000000001,"janw2":1112.8,"janw3":950.4000000000001,"janw4":1107.2,"ttlJanuary":783.2,"febw1":1081.6000000000001,"febw2":887.2,"febw3":1508.8,"febw4":1256,"ttlFebruary":2904.8,"marchw1":3028.8,"marchw2":3164,"marchw3":1944.8000000000002,"marchw4":1873.6000000000001,"marchw5":2018.4,"ttlMarch":915.2,"q1":1199.2,"aprilw1":1127.2,"aprilw2":1260,"aprilw3":816,"aprilw4":1285.6,"ttlApril":633.6,"mayw1":792,"mayw2":962.4000000000001,"mayw3":1185.6,"mayw4":1186.4,"ttlMay":895.2,"junew1":1112,"junew2":1152.8,"junew3":852.8000000000001,"junew4":621.6,"junew5":1159.2,"ttlJune":1952,"q2":4625.6,"julyw1":940,"julyw2":972,"julyw3":942.4000000000001,"julyw4":906.4000000000001,"ttlJuly":1066.4,"augw1":853.6,"augw2":800,"augw3":800,"augw4":746.4,"ttlAugust":746.4,"sepw1":640,"sepw2":586.4,"sepw3":586.4,"sepw4":586.4,"sepw5":586.4,"ttlSeptember":533.6,"q3":640,"octw1":586.4,"ttlOctober":586.4,"ttlNovember":0,"ttlDecember":0,"q4":0,"totalYear":0},{"columnValue":"Quest 128GB","secondValue":"Monthly Budget","ttlOctober":0,"ttlNovember":0},{"columnValue":"Quest 128GB","secondValue":"Yearly Budget","ttlOctober":0,"ttlNovember":0,"ttlDecember":0},{"columnValue":"Quest 128GB","secondValue":"Marketing Spend","ttlOctober":0,"ttlNovember":0,"ttlDecember":0,"q4":0,"totalYear":0},{"columnValue":"Quest 128GB","secondValue":"LY Actuals","ttlOctober":0,"ttlNovember":0,"ttlDecember":0,"q4":0,"totalYear":0},{"columnValue":"Quest 128GB","secondValue":"Like Item LY","octw2":"Digital ad","novw1":"Commercial","novw4":"Email blast","decw2":"Digital ad","ttlDecember":0,"q4":0,"totalYear":0},{"columnValue":"Quest 128GB","secondValue":"Notes","janw2":"Email, Ad","janw4":"Ad, Email","febw1":"10% Price","febw3":"Free shipping","marchw1":"Ad","marchw4":"Digital Ad","q1":"Email","aprilw1":"Bundle","aprilw4":"Global homepage","mayw1":"Commercial","mayw4":"In-store hot price","junew3":"Online only hot price","q2":"Ad","julyw2":"Bunlde","ttlJuly":"Email","augw2":"Digital ad","ttlAugust":"Commercial","sepw3":"Email blast","ttlSeptember":"Digital ad","ttlDecember":0},{"ttlDecember":0,"q4":0,"totalYear":0}]
    this.tempList = JSON.parse(JSON.stringify(this.rowList));
    this.calculateListValues();
  }
  public calculateListValues = (event?, changedList?) => {
    if (event) {
      const index = this.rowList.findIndex(row => row.secondValue === event.data.secondValue && row.columnValue === event.data.columnValue);
      if (index > -1) {
        event.newValue = +event.newValue;
        this.tempList[index][event.colDef.field] = Number(event.newValue);
      }
    }
    this.tempList.forEach(row => {
      if (row.secondValue === 'Final Expotential Smoothing' || row.secondValue === 'Final Linear Regression' || row.secondValue === `Final Holt's Double Expotenial Smoothing`) {
        Object.keys(row).forEach(key => {
          if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue') {
            row[key] = 0;
          }
        });
      }
    });
    this.tempList.forEach(row => {
      const selectedColumnList = this.chooserList.filter(row => !row.checked).map(el => el.name);
      if (row.secondValue === 'Final Expotential Smoothing') {
        let list = ['Primary Method Base', 'Expotential Smoothing', 'Linear Regression', `Holt's Double Expotential Smoothing`, 'Event Lift', 'Seasonality'];
        if (selectedColumnList.length > 0) {
          list = list.filter(item => !selectedColumnList.includes(item));
        }
        let toFindList = changedList ? changedList : this.tempList;
        const calculationList = toFindList.filter(item => list.includes(item.secondValue));
        calculationList.forEach(element => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              if (element.secondValue === 'Expotential Smoothing' || element.secondValue === 'Event Lift') {
                row[key] = +row[key];
                element[key] = +element[key];
                row[key] += +element[key];
              }
            }
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (element.secondValue === 'Expotential Smoothing' || element.secondValue === 'Event Lift' && flag) {
                row[key] = +row[key];
                element[key] = +element[key];
                row[key] += +element[key];
              }
            }
          });
        });
        calculationList.forEach(element => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              if (element.secondValue === 'Seasonality') {
                row[key] = +row[key];
                row[key] *= +element[key];
              }
            }
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (element.secondValue === 'Seasonality' && flag) {
                row[key] = +row[key];
                row[key] *= +element[key];
              }
            }
          });
        });
      }
      if (row.secondValue === 'Final Linear Regression') {
        let list = ['Primary Method Base', 'Expotential Smoothing', 'Linear Regression', `Holt's Double Expotential Smoothing`, 'Event Lift', 'Seasonality'];
        if (selectedColumnList.length > 0) {
          list = list.filter(item => !selectedColumnList.includes(item));
        }
        let toFindList = changedList ? changedList : this.tempList;
        const calculationList = toFindList.filter(item => list.includes(item.secondValue));
        calculationList.forEach(element => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              if (element.secondValue === 'Linear Regression' || element.secondValue === 'Event Lift') {
                row[key] = +row[key];
                element[key] = +element[key];
                row[key] += +element[key];
              }
            }
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (element.secondValue === 'Linear Regression' || element.secondValue === 'Event Lift' && flag) {
                row[key] = +row[key];
                element[key] = +element[key];
                row[key] += +element[key];
              }
            }
          });
        });
        calculationList.forEach(element => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              if (element.secondValue === 'Seasonality') {
                row[key] = +row[key];
                row[key] *= +element[key];
              }
            }
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (element.secondValue === 'Seasonality' && flag) {
                row[key] = +row[key];
                row[key] *= +element[key];
              }
            }
          });
        });
      }
      if (row.secondValue === `Final Holt's Double Expotenial Smoothing`) {
        let list = ['Expotential Smoothing', `Holt's Double Expotenial Smoothing`, 'Event Lift', 'Seasonality'];
        if (selectedColumnList.length > 0) {
          list = list.filter(item => !selectedColumnList.includes(item));
        }
        let toFindList = changedList ? changedList : this.tempList;
        const calculationList = toFindList.filter(item => list.includes(item.secondValue));
        calculationList.forEach(element => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              if (element.secondValue === `Holt's Double Expotenial Smoothing` || element.secondValue === 'Event Lift') {
                row[key] = +row[key];
                element[key] = +element[key];
                row[key] += +element[key];
              }
            }
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (element.secondValue === `Holt's Double Expotenial Smoothing` || element.secondValue === 'Event Lift' && flag) {
                row[key] = +row[key];
                element[key] = +element[key];
                row[key] += +element[key];
              }
            }
          });
        });
        calculationList.forEach(element => {
          Object.keys(row).forEach(key => {
            const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
              if (element.secondValue === 'Seasonality') {
                row[key] = +row[key];
                row[key] *= +element[key];
              }
            }
            if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
              const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
              if (element.secondValue === 'Seasonality' && flag) {
                row[key] = +row[key];
                row[key] *= +element[key];
              }
            }
          });
        });
      }
      row['ttlJanuary'] = 0;
      row['ttlFebruary'] = 0;
      row['ttlMarch'] = 0;
      row['ttlApril'] = 0;
      row['ttlMay'] = 0;
      row['ttlJune'] = 0;
      row['ttlJuly'] = 0;
      row['ttlAugust'] = 0;
      row['ttlSeptember'] = 0;
      row['ttlOctober'] = 0;
      row['ttlNovember'] = 0;
      row['ttlDecember'] = 0;
      Object.keys(row).forEach(key => {
        const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
        if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && row.secondValue !== 'Notes' && columns.length < 1) {
          if (key.startsWith('jan')) {
            row['ttlJanuary'] += +row[key];
          }
          if (key.startsWith('feb')) {
            row['ttlFebruary'] += +row[key];
          }
          if (key.startsWith('march')) {
            row['ttlMarch'] += +row[key];
          }
          if (key.startsWith('april')) {
            row['ttlApril'] += +row[key];
          }
          if (key.startsWith('may')) {
            row['ttlMay'] += +row[key];
          }
          if (key.startsWith('june')) {
            row['ttlJune'] += +row[key];
          }
          if (key.startsWith('july')) {
            row['ttlJuly'] += +row[key];
          }
          if (key.startsWith('aug')) {
            row['ttlAugust'] += +row[key];
          }
          if (key.startsWith('sep')) {
            row['ttlSeptember'] += +row[key];
          }
          if (key.startsWith('oct')) {
            row['ttlOctober'] += +row[key];
          }
          if (key.startsWith('nov')) {
            row['ttlNovember'] += +row[key];
          }
          if (key.startsWith('dec')) {
            row['ttlDecember'] += +row[key];
          }
          row['q1'] = row['ttlJanuary'] + row['ttlFebruary'] + row['ttlMarch'];
          row['q2'] = row['ttlApril'] + row['ttlMay'] + row['ttlJune'];
          row['q3'] = row['ttlJuly'] + row['ttlAugust'] + row['ttlSeptember'];
          row['q4'] = row['ttlOctober'] + row['ttlNovember'] + row['ttlDecember'];
          row['totalYear'] = row['q1'] + row['q2'] + row['q3'] + row['q4'];
        }
        if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && row.secondValue !== 'Notes' && columns.length > 0) {
          const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
          if (key.startsWith('jan') && flag) {
            row['ttlJanuary'] += +row[key];
          }
          if (key.startsWith('feb') && flag) {
            row['ttlFebruary'] += +row[key];
          }
          if (key.startsWith('march') && flag) {
            row['ttlMarch'] += +row[key];
          }
          if (key.startsWith('april') && flag) {
            row['ttlApril'] += +row[key];
          }
          if (key.startsWith('may') && flag) {
            row['ttlMay'] += +row[key];
          }
          if (key.startsWith('june') && flag) {
            row['ttlJune'] += +row[key];
          }
          if (key.startsWith('july') && flag) {
            row['ttlJuly'] += +row[key];
          }
          if (key.startsWith('aug') && flag) {
            row['ttlAugust'] += +row[key];
          }
          if (key.startsWith('sep') && flag) {
            row['ttlSeptember'] += +row[key];
          }
          if (key.startsWith('oct') && flag) {
            row['ttlOctober'] += +row[key];
          }
          if (key.startsWith('nov') && flag) {
            row['ttlNovember'] += +row[key];
          }
          if (key.startsWith('dec') && flag) {
            row['ttlDecember'] += +row[key];
          }
          row['q1'] = row['ttlJanuary'] + row['ttlFebruary'] + row['ttlMarch'];
          row['q2'] = row['ttlApril'] + row['ttlMay'] + row['ttlJune'];
          row['q3'] = row['ttlJuly'] + row['ttlAugust'] + row['ttlSeptember'];
          row['q4'] = row['ttlOctober'] + row['ttlNovember'] + row['ttlDecember'];
          row['totalYear'] = row['q1'] + row['q2'] + row['q3'] + row['q4'];
          if (row.secondValue === 'Seasonality') {
            row['ttlJanuary'] = +row['ttlJanuary'].toFixed(2);
            row['ttlFebruary'] = +row['ttlFebruary'].toFixed(2);
            row['ttlMarch'] = +row['ttlMarch'].toFixed(2);
            row['ttlApril'] = +row['ttlApril'].toFixed(2);
            row['ttlMay'] = +row['ttlMay'].toFixed(2);
            row['ttlJune'] = +row['ttlJune'].toFixed(2);
            row['ttlJuly'] = +row['ttlJuly'].toFixed(2);
            row['ttlAugust'] = +row['ttlAugust'].toFixed(2);
            row['ttlSeptember'] = +row['ttlSeptember'].toFixed(2);
            row['ttlOctober'] = +row['ttlOctober'].toFixed(2);
            row['ttlNovember'] = +row['ttlNovember'].toFixed(2);
            row['ttlDecember'] = +row['ttlDecember'].toFixed(2);
            row['q1'] = +row['q1'].toFixed(2);
            row['q2'] = +row['q2'].toFixed(2);
            row['q3'] = +row['q3'].toFixed(2);
            row['q4'] = +row['q4'].toFixed(2);
          }
        }
      });
    });
    const selectedColumnList = this.chooserList.filter(row => !row.checked).map(el => el.name);
    let list = JSON.parse(JSON.stringify(this.tempList));
    if (selectedColumnList.length > 0) {
      list = this.tempList.filter(row => !selectedColumnList.includes(row.secondValue));
    }
    for (let index = 0; index < list.length; index++) {
      Object.keys(list[index]).forEach(key => {
        if (!isNaN(list[index][key])) {
          if (list[index].secondValue !== 'Seasonality') {
            list[index][key] = list[index][key] ? Number(list[index][key]).toFixed(0) : 0;
          }
        }
      })
    }
    setTimeout(() => {
      if (this.gridOptions && this.gridOptions.api) {
        this.gridOptions.api.setRowData(list);
      }
    }, 100);
    const array = ['Final Expotential Smoothing', 'Final Linear Regression', `Final Holt's Double Expotenial Smoothing`, `Final Total Forecast`];
    const listForGraph = list.filter(row => array.includes(row.secondValue))
    this.applyGraph(listForGraph);
    for (let index = 0; index < this.rowList.length; index++) {
      Object.keys(this.rowList[index]).forEach(key => {
        if (!isNaN(this.rowList[index][key])) {
          if (this.rowList[index].secondValue !== 'Seasonality') {
            this.rowList[index][key] = this.rowList[index][key] ? Number(this.rowList[index][key]).toFixed(0) : 0;
          }
        }
      })
    }

    // this.rowList = list;
  }
  getSeries = (object) => {
    const objList = [];
    Object.keys(object).forEach(key => {
      if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue') {
        const newObject = {
          name: key,
          value: Number(object[key])
        }
        objList.push(newObject)
      }
    });
    return objList;
  }
  openExcelImportDialog(data, templateRef?: TemplateRef<any>): void {
    this.dialogRef = this.dialog.open(this.excelImport, { width: '500px', data: data || {} });
  }
  onCellValueChanged = (value) => {
    this.calculateListValues(value);
  }
  onFilterTextBoxChanged(event) {
    this.gridOptions.api.setQuickFilter(event.target.value);
  }
  onGridReady(params) {
    this.gridApi = params.api;
  }
  public onSubmit = () => {
  }
  selectAllSelected(flag: boolean): void {
    if (flag) {
      this.chooserList = this.chooserList.map(row => ({ ...row, checked: true }))
    } else {
      this.chooserList = this.chooserList.map(row => ({ ...row, checked: false }))
    }
  }
  public onSave = () => {
    // let newColumnDefs = this.columnDefs.filter(column => column.show);
    // const cols = JSON.parse(JSON.stringify(this.tempColDefs));
    // const list = cols.map(column => {
    //   if (column.children) {
    //     column.children = column.children.filter(col => col.show);
    //     column.children = column.children.map(col => ({ ...col, editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' } }))
    //   }
    //   return column;
    // });
    // newColumnDefs = newColumnDefs.length > 0 ? list.push(...newColumnDefs) : list as any;
    // this.gridOptions.api.setColumnDefs(newColumnDefs);
    this.calculateListValues();
    this.dialogRef.close();
  }
  onSelect(event) {
    console.log(event);
    this.files.push(...event.addedFiles);
  }
  exportToExcel = () => {
    this.gridApi.exportDataAsCsv();
  }
  onRemove(event) {
    console.log(event);
    this.files.splice(this.files.indexOf(event), 1);
  }
  loadFile(res) {

    /* wire up file reader */
    this.spinner.show();
    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(res);
    reader.onload = (e: any) => {
      /* create workbook */
      const binarystr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary', cellDates: true });
      /* selected the first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      /* save data */
      const data = XLSX.utils.sheet_to_json(ws); // to get 2d array pass 2nd parameter as object {header: 1}
      console.log(data);
      this.rowList = data;
      console.log(JSON.stringify(this.rowList));
      // for (let i = 0; i < this.ItemMasterList.length; i++) {
      //   if (this.ItemMasterList[i]['']) {
      //     this.ItemMasterList[i][''] =
      //   }
      // }
      this.spinner.hide();
    };
  }
  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.itemSeletedList.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.searchItem.setValue('');
  }

  remove(fruit: string): void {
    const index = this.itemSeletedList.indexOf(fruit);

    if (index >= 0) {
      this.itemSeletedList.splice(index, 1);
    }
  }
  selected(event: MatAutocompleteSelectedEvent): void {
    this.itemSeletedList.push(event.option.viewValue);
    this.searchItemInput.nativeElement.value = '';
    this.searchItem.setValue(null);
  }
  selectedCustomer(event: MatAutocompleteSelectedEvent): void {
    this.customerSelectedList.push(event.option.viewValue);
    this.searchCustomerInput.nativeElement.value = '';
    this.searchCustomer.setValue(null);
  }
  removeCustomer(fruit: string): void {
    const index = this.customerSelectedList.indexOf(fruit);

    if (index >= 0) {
      this.customerSelectedList.splice(index, 1);
    }
  }
  addCustomer(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our Customer
    if ((value || '').trim()) {
      this.customerSelectedList.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.searchCustomer.setValue('');
  }
  onItemSelect(item?: boolean, items?) {
    var columns = [];
    var newColumnDefs = [];
    columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
    // const columnDefs = this.columnDefs;
    if (columns && columns.length > 0 && !item) {
      const columnDefs = JSON.parse(JSON.stringify(this.tempColDefs));
      const list = columnDefs.map(column => {
        if (column.children) {
          // || col.field.startsWith('q') || col.field.startsWith('totalYear')
          column.children = column.children.filter(col => columns.findIndex((a, b) => col.field.indexOf(a) > -1) > -1);
          column.children = column.children.map(col => ({ ...col, editable: params => { return params.data['secondValue'] !== 'Final Total Forecast' } }))
        }
        return column;
      });
      newColumnDefs = newColumnDefs.length > 0 ? list.push(...newColumnDefs) : list as any;
      newColumnDefs = newColumnDefs.filter(col => columns.findIndex((a, b) => ((col.field === '' || col.pinned))) > -1);
      // newColumnDefs = newColumnDefs.filter(col => (col.field === '' || col.pinned));
      newColumnDefs = newColumnDefs.map(col => ({ ...col, cellRenderer: col.field === 'firstValue' ? params => `<b>${params.value ? params.value : ''}</b>` : null }))
      for (let i = 0; i < newColumnDefs.length; i++) {
        if (newColumnDefs[i].field === 'secondValue') {
          newColumnDefs[i] = {
            ...newColumnDefs[i],
            cellRenderer: '',
            cellRendererParams: (params) => {
              const items = ['Primary Method Base', 'Expotential Smoothing', 'Linear Regression', `Holt's Double Expotential Smoothing`];
              const obj = {
                isDropDown: items.includes(params.data.secondValue) ? true : false, // pass the field value here
                onChange: this.filterData.bind(this),
              }
              return obj;
            },
          }
        }
      }
      this.gridOptions.api.setColumnDefs(newColumnDefs);
    } else {
      if (item) {
        this.timeframeSelectedList = items
      }
      this.gridOptions.api.setColumnDefs(this.columnDefs);
    }
    // if (columns && columns.length > 0) {
    //   columnDefs.forEach(colm => {
    //     colm.children = colm.children && colm.children.length > 0 ? colm && colm.children.filter(col => columns.findIndex((a, b) => col.field.indexOf(a) > -1) > -1) : colm.children
    //   });
    // }
    this.calculateListValues();
  }
  onSelectAll(items: any) {
    this.onItemSelect(true, items)
  }
  openFullScreen = (id: string) => {
    const domGrid = document.getElementById(id) as any;
    if (domGrid) {
      domGrid.webkitRequestFullscreen();
    }
  }
  applyGraph(totalCalculatedList) {
    const data = {
      chart: {
        caption: "",
        yaxisname: "",
        subcaption: "",
        showhovereffect: "1",
        lineThickness: "4",
        "width": "100%",
        "height": "150px",
        numbersuffix: "",
        "paletteColors": "#8D009D,#F8486E, #1C9FAD, #2480D3",
        drawcrossline: "1",
        plottooltext: "<b>$dataValue</b>",
        theme: "fusion"
      },
      categories: [
        {
          category: this.getLabels()
        }
      ],
      dataset: totalCalculatedList.map(item => ({ seriesname: item.secondValue, data: this.getList(item) }))
    };
    this.dataSource = data as any;
  }
  public getLabels = () => {
    const el = this.tempList[0];
    const list = [];
    Object.keys(el).forEach(key => {
      const columns = this.timeframeSelectedList.map(res => res.item_id.toLowerCase());
      if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length < 1) {
        list.push({ label: this.getKeyValue(key) });
      }
      if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue' && columns.length > 0) {
        const flag = columns.findIndex((a, b) => key.indexOf(a) > -1) > -1;
        if (flag) {
          list.push({ label: this.getKeyValue(key) });
        }
      }
    });
    return list;
  }
  getKeyValue(key) {
    const list = [
      { key: 'janw1', value: '01/05/2020' },
      { key: 'janw2', value: '01/12/2020' },
      { key: 'janw3', value: '01/19/2020' },
      { key: 'janw4', value: '01/26/2020' },
      { key: 'ttlJanuary', value: 'Total January' },
      { key: 'febw1', value: '02/02/2020' },
      { key: 'febw2', value: '02/09/2020' },
      { key: 'febw3', value: '02/16/2020' },
      { key: 'febw4', value: '02/23/2020' },
      { key: 'ttlFebruary', value: 'Total February' },
      { key: 'marchw1', value: '03/01/2020' },
      { key: 'marchw2', value: '03/08/2020' },
      { key: 'marchw3', value: '03/15/2020' },
      { key: 'marchw4', value: '03/22/2020' },
      { key: 'marchw5', value: '03/29/2020' },
      { key: 'ttlMarch', value: 'Total March' },
      { key: 'q1', value: 'Q1' },
      { key: 'aprilw1', value: '04/05/2020' },
      { key: 'aprilw2', value: '04/12/2020' },
      { key: 'aprilw3', value: '04/19/2020' },
      { key: 'aprilw4', value: '04/26/2020' },
      { key: 'ttlApril', value: 'Total April' },
      { key: 'mayw1', value: '05/03/2020' },
      { key: 'mayw2', value: '05/10/2020' },
      { key: 'mayw3', value: '05/17/2020' },
      { key: 'mayw4', value: '05/24/2020' },
      { key: 'ttlMay', value: 'Total May' },
      { key: 'junew1', value: '05/31/2020' },
      { key: 'junew2', value: '06/07/2020' },
      { key: 'junew3', value: '06/14/2020' },
      { key: 'junew4', value: '06/21/2020' },
      { key: 'junew5', value: '06/28/2020' },
      { key: 'ttlJune', value: 'Total June' },
      { key: 'q2', value: 'Q2' },
      { key: 'julyw1', value: '07/05/2020' },
      { key: 'julyw2', value: '07/12/2020' },
      { key: 'julyw3', value: '07/19/2020' },
      { key: 'julyw4', value: '07/26/2020' },
      { key: 'ttlJuly', value: 'Total July' },
      { key: 'augw1', value: '08/02/2020' },
      { key: 'augw2', value: '08/09/2020' },
      { key: 'augw3', value: '08/16/2020' },
      { key: 'augw4', value: '08/23/2020' },
      { key: 'ttlAugust', value: 'Total August' },
      { key: 'sepw1', value: '09/30/2020' },
      { key: 'sepw2', value: '09/06/2020' },
      { key: 'sepw3', value: '09/13/2020' },
      { key: 'sepw4', value: '09/20/2020' },
      { key: 'sepw5', value: '09/27/2020' },
      { key: 'ttlSeptember', value: 'Total September' },
      { key: 'q3', value: 'Q3' },
      { key: 'octw1', value: '10/04/2020' },
      { key: 'octw2', value: '10/11/2020' },
      { key: 'octw3', value: '10/18/2020' },
      { key: 'octw4', value: '10/25/2020' },
      { key: 'ttlOctober', value: 'Total October' },
      { key: 'novw1', value: '11/01/2020' },
      { key: 'novw2', value: '11/08/2020' },
      { key: 'novw3', value: '11/15/2020' },
      { key: 'novw4', value: '11/22/2020' },
      { key: 'ttlNovember', value: 'Total November' },
      { key: 'novw5', value: '11/29/2020' },
      { key: 'decw1', value: '12/06/2020' },
      { key: 'decw2', value: '12/13/2020' },
      { key: 'decw3', value: '12/20/2020' },
      { key: 'decw4', value: '12/27/2020' },
      { key: 'ttlDecember', value: 'Total December' },
      { key: 'q4', value: 'Q4' },
      { key: 'totalYear', value: 'Total Year' },
    ];
    return list.find(item => item.key === key).value;
  }
  getList = (row) => {
    const list = [];
    Object.keys(row).forEach(key => {
      if (key !== 'secondValue' && key !== 'firstValue' && key !== 'columnValue') {
        list.push(row[key]);
      }
    });
    return list.map(item => ({ value: item }))
  }
  filterData = (value) => {
    const index = value.rowData.rowIndex + 4;
    const list = JSON.parse(JSON.stringify(this.tempList));
    Object.keys(list[index]).forEach(key => {
      if (key !== 'firstValue' && key !== 'columnValue') {
        if ((key.endsWith('w1') || key.endsWith('w2') || key.endsWith('w3') || key.endsWith('w4') || key.endsWith('w5'))) {
          if (value.event.value === 'Linear Regression') {
            list[index][key] = +list[index][key];
            list[index][key] *= 1.2;
          } else if (value.event.value === `Holt's Double Expotential Smoothing`) {
            list[index][key] = +list[index][key];
            list[index][key] *= 0.8;
          } else {
            list[index][key] = +this.rowList[index][key];
            // list[index][key] *= 0.8;
          }
        }
        if (key === 'secondValue') {
          list[index][key] = value.event.value;
        }
      }
    });
    this.tempList = [...list];
    this.calculateListValues(null, list);
  }
}
